import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="overlay"
export default class extends Controller {
  static targets = ["form"]

  changed(){
    this.formTarget.requestSubmit();
  }
}
